<template>
  <div class="min-h-screen bg-black text-white flex flex-col items-center justify-center p-6 text-center">
    <a href="/" class="mb-8"><img src="/images/logo_testo.png" alt="StreetStock Logo" class="h-12" /></a>
    <h1 class="text-2xl font-bold mb-2">Invia il messaggio (3/3)</h1>
    <p class="mb-6 opacity-80">
      Apri WhatsApp e invia al negozio di {{ store.city }} il messaggio di adesione.
    </p>

    <div class="flex flex-col gap-3 w-full max-w-xs">
      <a :href="waUrl" target="_blank" rel="noopener"
         class="btn py-3 rounded-xl font-semibold"
         @click="clicked = true">
        Invia su WhatsApp
      </a>

      <button class="btn-secondary py-3 rounded-xl font-semibold"
              :disabled="!canFinish"
              :class="{'disabled': !canFinish}"
              @click="finish">
        Completa
      </button>

      <a href="/join/save-contact" class="text-sm opacity-70 mt-2 underline">Torna indietro</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SendMessage',
  data(){ return { store: null, clicked: false, hasRefocused: false } },
  created(){
    const raw = localStorage.getItem('ss_selected_store')
    if(!raw){ window.location.href='/join'; return }
    this.store = JSON.parse(raw)
    window.addEventListener('focus', this.onFocus)
  },
  beforeDestroy(){
    window.removeEventListener('focus', this.onFocus)
  },
  computed:{
    waUrl(){
      const phone = (this.store.phone||'').replace(/\D/g,'')
      const text  = encodeURIComponent('Ciao, voglio unirmi alla community di street stock market')
      return `https://wa.me/39${phone}?text=${text}`
    },
    canFinish(){
      // abilita "Completa" dopo che l'utente ha cliccato e poi è tornato alla pagina
      return this.clicked && this.hasRefocused
    }
  },
  methods:{
    onFocus(){ this.hasRefocused = true },
    finish(){
      // opzionale: pulisci scelta
      // localStorage.removeItem('ss_selected_store')
      window.location.href = '/join/done'
    }
  }
}
</script>

<style scoped>
.btn { background:#3aa7df; color:#fff; text-decoration:none; transition:.2s; }
.btn:hover { background:#2f93c6; }
.btn-secondary { background:#10b981; color:#fff; border:none; }
.btn-secondary.disabled { opacity:.45; pointer-events:none; }
</style>
